const onFormStyleUpdates = {
  methods: {
    captchaLetters(params) {
      this.$store.dispatch('setDropletVal', {
        drp: params.drp,
        key: 'captchaLetters',
        val: params.val,
      });
    },
  },
};

export { onFormStyleUpdates };



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/form/components/_edit-options/on-update.js